var React = require('react');

function TagClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z"}));
}

TagClose.defaultProps = {"height":"24px","viewBox":"0 -960 960 960","width":"24px","fill":"#e3e3e3"};

module.exports = TagClose;

TagClose.default = TagClose;
